module.exports = __webpack_public_path__ + "img/JPUTLogoHorizontalBlack.bd4ef37a.png";